export const BRAND_BLUE = "#00336C";
export const BRAND_GREEN = "#648315";
